import { cn, InputTextarea, Modal, PrimaryButton } from '@artprov/design-system'
import React from 'react'
import PanelAutorizantes from '../../../common/components/PanelAutorizantes'

export default function ModalMensaje({ openModal, onCloseModal, mensaje = "Mensaje en el inputTextArea", subtitulo = "subtitulo", titulo = "Titulo del modal" }) {
    return (
        <Modal.Container
            open={openModal}
            className={cn("overflow-x-hidden")}
            onClose={onCloseModal}
            closeOnClickOutside={false}
        >
            <Modal.Content width={489} >
                <Modal.Header>
                    <Modal.Title className='pl-2'>{titulo}</Modal.Title>
                    <Modal.Close onClose={() => onCloseModal()} />
                </Modal.Header>
                <Modal.Body className='pl-1'>
                    <InputTextarea label={subtitulo} value={mensaje} disabled={true} className={{ container: "w-[420px]" }} />
                </Modal.Body>
                <Modal.Footer>
                    <Modal.AcceptButton onClick={() => onCloseModal()} >Aceptar</Modal.AcceptButton>
                </Modal.Footer>
            </Modal.Content>
        </Modal.Container>
    )
}
